module.exports = __webpack_public_path__ + "static/img/machin_l.6414518f.png";